/* HOMELUX custom sections — Vanilla JS, keine Abhängigkeiten.
   Läuft mit Dawn (defer geladen) und im Theme-Editor (Section-Reload sicher). */
(function () {
  'use strict';

  /* Mehrfach eingebundenes Script darf Listener nicht doppelt anhängen. */
  function once(el, key) {
    if (!el || el.dataset[key] === '1') return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------------- Mega Menu (Desktop) ---------------- */
  function initMegaMenu(root) {
    if (!once(root, 'hlMegaReady')) return;
    var items = root.querySelectorAll('[data-hl-navitem]');
    var closeTimer;

    function closeAll() {
      items.forEach(function (i) { i.setAttribute('data-open', 'false'); });
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-hl-navtrigger]');

      item.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        closeAll();
        item.setAttribute('data-open', 'true');
      });
      item.addEventListener('mouseleave', function () {
        closeTimer = window.setTimeout(closeAll, 120);
      });

      if (trigger) {
        trigger.addEventListener('focus', function () { closeAll(); item.setAttribute('data-open', 'true'); });
        trigger.addEventListener('click', function (event) {
          if (item.querySelector('.hl-mega')) {
            var open = item.getAttribute('data-open') === 'true';
            if (!open) { event.preventDefault(); closeAll(); item.setAttribute('data-open', 'true'); }
          }
        });
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAll();
    });
  }

  /* ---------------- Mobile Drawer ---------------- */
  function initDrawer(root) {
    var drawer = root.querySelector('[data-hl-drawer]');
    var overlay = root.querySelector('[data-hl-drawer-overlay]');
    if (!drawer) return;
    if (!once(drawer, 'hlDrawerReady')) return;

    function toggle(open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      if (overlay) overlay.setAttribute('data-open', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    root.querySelectorAll('[data-hl-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { toggle(true); });
    });
    root.querySelectorAll('[data-hl-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { toggle(false); });
    });
    if (overlay) overlay.addEventListener('click', function () { toggle(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggle(false); });
  }

  /* ---------------- Carousel (scroll-snap + Pfeile + Dots) ---------------- */
  function initCarousel(scope) {
    var track = scope.querySelector('[data-hl-track]');
    if (!track) return;
    if (!once(track, 'hlCarouselReady')) return;

    var prev = scope.querySelector('[data-hl-prev]');
    var next = scope.querySelector('[data-hl-next]');
    var dotsWrap = scope.querySelector('[data-hl-dots]');

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      var w = first.getBoundingClientRect().width + gap;
      var perView = Math.max(1, Math.round(track.clientWidth / w));
      return w * perView;
    }

    function pages() {
      return Math.max(1, Math.ceil((track.scrollWidth - track.clientWidth) / step()) + 1);
    }

    function buildDots() {
      if (!dotsWrap) return;
      var total = pages();
      dotsWrap.innerHTML = '';
      if (total < 2) return;
      for (var i = 0; i < total; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Seite ' + (i + 1));
        b.dataset.index = String(i);
        b.addEventListener('click', function (e) {
          track.scrollTo({ left: step() * parseInt(e.currentTarget.dataset.index, 10), behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
      }
      sync();
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (dotsWrap) {
        var idx = Math.round(track.scrollLeft / step());
        dotsWrap.querySelectorAll('button').forEach(function (b, i) {
          b.setAttribute('aria-current', i === idx ? 'true' : 'false');
        });
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', function () { buildDots(); });
    buildDots();
    sync();
  }

  /* ---------------- AJAX "In den Warenkorb" ---------------- */
  function initAjaxCart(scope) {
    scope.querySelectorAll('form[data-hl-atc]').forEach(function (form) {
      if (!once(form, 'hlAtcReady')) return;
      form.addEventListener('submit', function (event) {
        if (form.dataset.hlAtc !== 'ajax') return;
        event.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = '…'; }

        var body = new FormData(form);
        body.append('sections', 'hl-header,cart-drawer,cart-icon-bubble');

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: body
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('hl:cart:added'));
            if (!document.querySelector('[data-hl-cart-drawer]')) {
              // Kein eigener Drawer: Kart-Seite nur öffnen, wenn sie existiert (keine 404)
              var cartUrl = (window.Shopify && Shopify.routes ? Shopify.routes.cart_url : '/cart');
              fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js')
                .then(function () { window.location.href = cartUrl; })
                .catch(function () { cartModule.open(); });
              return;
            }
            // Kein "Hinzugefügt"-Popup -> Drawer als Fallback öffnen
            if (!document.querySelector('[data-hl-added]')) cartModule.open();
            cartModule.refresh();  // Drawer-Inhalt im Hintergrund auffrischen
            refreshBubble();
          })
          .catch(function () {
            // Kein Seitenwechsel — Drawer/Popup öffnen, keine 404
            if (document.querySelector('[data-hl-cart-drawer]')) { cartModule.open(); cartModule.refresh(); }
          })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.innerHTML = label; }
          });
      });
    });
  }

  function refreshBubble() {
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-hl-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function () {});
  }

  /* ---------------- Warenkorb-Drawer ---------------- */
  var cartModule = {
    root: null,
    drawer: null,
    overlay: null,
    setOpen: null,
    ready: false,
    ensure: function () {
      if (this.ready) return;
      this.root = document.querySelector('[data-hl-cart]');
      if (!this.root) return;
      this.drawer = this.root.querySelector('[data-hl-cart-drawer]');
      this.overlay = this.root.querySelector('.hl-cart__overlay');
      var self = this;
      this.setOpen = function (open) {
        if (self.drawer) self.drawer.setAttribute('data-open', open ? 'true' : 'false');
        if (self.overlay) self.overlay.setAttribute('data-open', open ? 'true' : 'false');
        document.documentElement.style.overflow = open ? 'hidden' : '';
        document.body.classList.toggle('hl-cart-open', !!open);
      };
      this.root.querySelectorAll('[data-hl-cart-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.setOpen(false); });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.setOpen) self.setOpen(false); });
      this.wireItems();
      this.ready = true;
    },
    open: function () { this.ensure(); if (this.setOpen) this.setOpen(true); },
    close: function () { this.ensure(); if (this.setOpen) this.setOpen(false); },
    wireItems: function () {
      // Kann nach jedem Refresh erneut laufen (neue Buttons bekommen Handler)
      if (!this.root) return;
      var self = this;
      this.root.querySelectorAll('[data-hl-cart-qty]').forEach(function (btn) {
        if (btn.dataset.hlWired) return; btn.dataset.hlWired = '1';
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-hl-cart-item]');
          var current = 1;
          if (item) { var n = item.querySelector('[data-hl-qty-num]'); if (n) current = parseInt(n.textContent, 10) || 1; }
          self.change(btn.dataset.hlLine, Math.max(1, current + (parseInt(btn.dataset.hlCartQty, 10) || 0)));
        });
      });
      this.root.querySelectorAll('[data-hl-cart-remove]').forEach(function (btn) {
        if (btn.dataset.hlWired) return; btn.dataset.hlWired = '1';
        btn.addEventListener('click', function () { self.change(btn.dataset.hlLine, 0); });
      });
      // Gutscheincode
      this.root.querySelectorAll('[data-hl-cart-discount]').forEach(function (form) {
        if (form.dataset.hlWiredDiscount) return; form.dataset.hlWiredDiscount = '1';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var input = form.querySelector('input[name="discount"]');
          var code = input ? input.value.trim() : '';
          var body = new URLSearchParams();
          body.append('discount', code);
          fetch('/cart/update.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
            .then(function (r) { return r.json(); })
            .then(function () { cartModule.refresh(); })
            .catch(function () { if (cartModule.drawer) cartModule.open(); });
        });
      });
    },
    change: function (line, qty) {
      var body = new URLSearchParams();
      body.append('line', line);
      body.append('quantity', qty);
      var root = document.querySelector('[data-hl-cart]');
      if (root) root.classList.add('hl-cart--loading');
      fetch('/cart/change.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
        .then(function (r) { return r.json(); })
        .then(function () { cartModule.refresh(); })
        .catch(function () { if (cartModule.drawer) cartModule.open(); });
    },
    refresh: function () {
      var root = document.querySelector('[data-hl-cart]');
      if (!root) return Promise.resolve();
      // Section-ID dynamisch aus dem DOM ermitteln (robust gegen Schlüssel-Abweichung)
      var secEl = root.closest('.shopify-section');
      var secId = secEl ? secEl.id.replace('shopify-section-', '') : 'hl_cart_drawer';
      root.classList.add('hl-cart--loading');
      return fetch('/?sections=' + secId)
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections[secId];
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var src = doc.querySelector('[data-hl-cart]');
            if (src) {
              ['items', 'foot', 'ship', 'rec'].forEach(function (key) {
                var so = src.querySelector('[data-hl-cart-' + key + ']');
                var de = root.querySelector('[data-hl-cart-' + key + ']');
                if (so && de) de.innerHTML = so.innerHTML;
              });
            }
          }
          refreshBubble();
        })
        .catch(function () {})
        .finally(function () {
          // Garantiert entsperren, egal ob Request ok oder fehlgeschlagen
          if (root) root.classList.remove('hl-cart--loading');
          cartModule.wireItems();
          initAjaxCart(root);   // Empfehlungs-Add-Buttons im Drawer neu verdrahten
        });
    }
  };

  /* Globale API: Drawer öffnen (für Popup „Warenkorb anzeigen“) */
  window.HL_openCartDrawer = window.HL_openCartDrawer || function () {
    cartModule.ensure();
    cartModule.open();
    cartModule.refresh();
  };

  /* ---------------- Öffnen via Header-Warenkorb-Button ------------- */
  function initCartOpen(scope) {
    scope.querySelectorAll('[data-hl-cart-open]').forEach(function (btn) {
      if (!once(btn, 'hlCartOpenReady')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!document.querySelector('[data-hl-cart-drawer]')) {
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.cart_url : '/cart');
          return;
        }
        cartModule.ensure();
        cartModule.open();
        cartModule.refresh();
      });
    });
  }

  /* ---------------- Kollektion: Sortierung + Filter umschalten --------- */
  function initCollection(scope) {
    scope.querySelectorAll('[data-hl-sort]').forEach(function (sel) {
      if (!once(sel, 'hlSortReady')) return;
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        window.location.href = url.toString();
      });
    });
    scope.querySelectorAll('[data-hl-filter-toggle]').forEach(function (btn) {
      if (!once(btn, 'hlFilterToggleReady')) return;
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    scope.querySelectorAll('[data-hl-panel-close]').forEach(function (btn) {
      if (!once(btn, 'hlPanelCloseReady')) return;
      btn.addEventListener('click', function () {
        var panel = btn.closest('[data-hl-panel]');
        if (!panel) return;
        panel.classList.remove('is-open');
        var trig = document.querySelector('[data-hl-filter-toggle][aria-controls="' + panel.id + '"]');
        if (trig) trig.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------------- Scroll-Reveal (Premium) ---------------- */
  function initReveal() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('hl-js');
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.hl-section').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.hl-section').forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Warenkorb-Seite (großer Warenkorb) ---------------- */
  function initCartPage(scope) {
    var root = scope.querySelector('[data-hl-cart-page]');
    if (!root) return;
    if (!once(root, 'hlCartPageReady')) return;

    function reload() { window.location.reload(); }
    function post(endpoint, params) {
      var body = new URLSearchParams();
      Object.keys(params).forEach(function (k) { body.append(k, params[k]); });
      return fetch(endpoint, { method: 'POST', headers: { Accept: 'application/json' }, body: body });
    }

    root.querySelectorAll('[data-hl-cart-qty]').forEach(function (btn) {
      if (btn.dataset.hlWired) return; btn.dataset.hlWired = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.hl-cartpage__item');
        var current = 1;
        if (item) { var n = item.querySelector('[data-hl-qty-num]'); if (n) current = parseInt(n.textContent, 10) || 1; }
        var qty = Math.max(1, current + (parseInt(btn.dataset.hlCartQty, 10) || 0));
        post('/cart/change.js', { line: btn.dataset.hlLine, quantity: qty }).then(reload).catch(reload);
      });
    });
    root.querySelectorAll('[data-hl-cart-remove]').forEach(function (btn) {
      if (btn.dataset.hlWired) return; btn.dataset.hlWired = '1';
      btn.addEventListener('click', function () {
        post('/cart/change.js', { line: btn.dataset.hlLine, quantity: 0 }).then(reload).catch(reload);
      });
    });
    root.querySelectorAll('[data-hl-cart-discount]').forEach(function (form) {
      if (form.dataset.hlWired) return; form.dataset.hlWired = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[name="discount"]');
        var code = input ? input.value.trim() : '';
        post('/cart/update.js', { discount: code }).then(reload).catch(reload);
      });
    });
  }

  /* ---------------- Live-Suche (Overlay) ---------------- */
  function initSearch() {
    var root = document.querySelector('[data-hl-search]');
    if (!root) return;
    if (!once(root, 'hlSearchReady')) return;
    var overlay = root.querySelector('.hl-search__overlay');
    var input = root.querySelector('[data-hl-search-input]');
    var results = root.querySelector('[data-hl-search-results]');
    var empty = root.querySelector('[data-hl-search-empty]');
    var currency = root.dataset.currency || '€';
    function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    function fmt(n) { return currency + String(n == null ? '' : n).replace('.', ','); }
    function open() {
      root.classList.add('is-open');
      document.body.classList.add('hl-search-open');
      if (input) { input.value = ''; }
      if (results) results.innerHTML = '';
      if (empty) empty.style.display = 'none';
      window.setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() {
      root.classList.remove('is-open');
      document.body.classList.remove('hl-search-open');
    }
    function render(data) {
      var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      if (empty) empty.style.display = products.length ? 'none' : 'block';
      if (!products.length) { if (results) results.innerHTML = ''; return; }
      var html = products.map(function (p) {
        var img = (p.featured_image && p.featured_image.url) ? '<img src="' + esc(p.featured_image.url) + '" alt="" loading="lazy">' : '';
        var price = p.price != null ? '<span class="hl-search__price">' + fmt(p.price) + '</span>' : '';
        var compare = (p.compare_at_price && Number(p.compare_at_price) > Number(p.price)) ? '<s class="hl-search__compare">' + fmt(p.compare_at_price) + '</s>' : '';
        return '<a class="hl-search__item" href="' + esc(p.url) + '">'
          + '<span class="hl-search__thumb">' + img + '</span>'
          + '<span class="hl-search__info"><span class="hl-search__name">' + esc(p.title) + '</span>'
          + '<span class="hl-search__prices">' + price + compare + '</span></span>'
          + '</a>';
      }).join('');
      html += '<a class="hl-search__all" href="/search?q=' + encodeURIComponent(input ? input.value : '') + '">Alle Ergebnisse ansehen</a>';
      results.innerHTML = html;
    }
    var timer;
    function onInput() {
      var q = input ? input.value.trim() : '';
      window.clearTimeout(timer);
      if (q.length < 2) { if (results) results.innerHTML = ''; if (empty) empty.style.display = 'none'; return; }
      timer = window.setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku')
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(function () {});
      }, 250);
    }
    document.querySelectorAll('[data-hl-search-open]').forEach(function (el) {
      el.addEventListener('click', function () {
        // Mobile: direkt zur vorhandenen Suchleiste, kein Overlay
        var mInput = document.querySelector('[data-hl-mobilesearch]');
        if (mInput && window.matchMedia && window.matchMedia('(max-width: 989px)').matches) {
          var bar = mInput.closest('.hl-header__searchbar');
          if (bar) bar.scrollIntoView({ behavior: 'smooth', block: 'center' });
          mInput.focus();
          return;
        }
        open();
      });
    });
    if (input) input.addEventListener('input', onInput);
    root.querySelectorAll('[data-hl-search-close]').forEach(function (el) { el.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------------- Mobile Suchleiste (Inline-Vorschläge) ---------------- */
  function initMobileSearch() {
    var input = document.querySelector('[data-hl-mobilesearch]');
    if (!input) return;
    if (once(input, 'hlMobileSearchReady')) return;
    var bar = input.closest('.hl-header__searchbar');
    var results = document.querySelector('[data-hl-mobilesearch-results]');
    var searchRoot = document.querySelector('[data-hl-search]');
    var currency = searchRoot ? (searchRoot.dataset.currency || '€') : '€';
    function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    function fmt(n) { return currency + String(n == null ? '' : n).replace('.', ','); }
    function render(data) {
      var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) { results.classList.remove('is-open'); return; }
      results.innerHTML = products.map(function (p) {
        var img = (p.featured_image && p.featured_image.url) ? '<img src="' + esc(p.featured_image.url) + '" alt="" loading="lazy">' : '';
        return '<a class="hl-msearch__item" href="' + esc(p.url) + '"><span class="hl-msearch__thumb">' + img + '</span><span class="hl-msearch__info"><span class="hl-msearch__name">' + esc(p.title) + '</span><span class="hl-msearch__price">' + fmt(p.price) + '</span></span></a>';
      }).join('') + '<a class="hl-msearch__all" href="/search?q=' + encodeURIComponent(input ? input.value : '') + '">Alle Ergebnisse</a>';
      results.classList.add('is-open');
    }
    var timer;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      window.clearTimeout(timer);
      if (q.length < 2) { results.classList.remove('is-open'); return; }
      timer = window.setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type')
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(function () {});
      }, 250);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && input.value.trim()) window.location = '/search?q=' + encodeURIComponent(input.value.trim());
    });
    document.addEventListener('click', function (e) { if (!bar.contains(e.target)) results.classList.remove('is-open'); });
  }

  /* ---------------- Header schrumpft beim Scrollen + Back-to-top ---------------- */
  function initHeaderScroll() {
    var header = document.querySelector('.hl-header');
    var toTop = document.querySelector('[data-hl-to-top]');
    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var scrolled = y > 80;
      if (header) header.classList.toggle('is-scrolled', scrolled);
      if (toTop) toTop.classList.toggle('is-visible', y > 400);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (toTop) {
      toTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  /* ---------------- Boot ---------------- */
  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-hl-header]').forEach(function (h) { initMegaMenu(h); initDrawer(h); });
    scope.querySelectorAll('[data-hl-carousel]').forEach(initCarousel);
    initAjaxCart(scope);
    if (scope === document) {
      cartModule.ensure();
      initCartOpen(document);
      initCollection(document);
      initCartPage(document);
      initSearch();
      initMobileSearch();
      initHeaderScroll();
      initReveal();
      // Zuletzt angesehen / Empfehlungen -> Drawer öffnen + aktualisieren
      document.addEventListener('hl:cart:refresh', function () {
        cartModule.open();
        cartModule.refresh();
        refreshBubble();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Theme-Editor: Sections werden neu gerendert
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('hl:cart:added', refreshBubble);
})();
